import { Temporal } from 'temporal-polyfill'

const getEasterDate = (year: number) => {
  const a = year % 19
  const d = (19 * a + 24) % 30
  const e = (2 * (year % 4) + 4 * (year % 7) + 6 * d + 5) % 7
  let marchDay = 22 + d + e
  if (marchDay === 57) marchDay = 50 // Exception : avril 19
  if (d === 28 && e === 6 && a > 10) marchDay = 49 // Exception : avril 18
  return Temporal.PlainDate.from({
    year,
    month: marchDay > 31 ? 4 : 3,
    day: marchDay > 31 ? marchDay - 31 : marchDay
  })
}

const plainDateToDate = (d: Temporal.PlainDate) =>
  new Date(d.year, d.month - 1, d.day)

export const getFrenchHolidays = (year: number): Date[] => {
  const easter = getEasterDate(year)
  return [
    Temporal.PlainDate.from({ year, month: 1, day: 1 }), // Jour de l'an
    easter.add({ days: 1 }), // Lundi de Pâques
    Temporal.PlainDate.from({ year, month: 5, day: 1 }), // Fête du Travail
    Temporal.PlainDate.from({ year, month: 5, day: 8 }), // Victoire 1945
    easter.add({ days: 39 }), // Ascension
    easter.add({ days: 50 }), // Lundi de Pentecôte
    Temporal.PlainDate.from({ year, month: 7, day: 14 }), // Fête Nationale
    Temporal.PlainDate.from({ year, month: 8, day: 15 }), // Assomption
    Temporal.PlainDate.from({ year, month: 11, day: 1 }), // Toussaint
    Temporal.PlainDate.from({ year, month: 11, day: 11 }), // Armistice
    Temporal.PlainDate.from({ year, month: 12, day: 25 }) // Noël
  ].map(plainDateToDate)
}
